import { flip, offset, shift } from '@floating-ui/react'

export const middleware = [
    flip({
        crossAxis: false,
        boundary: document.body,
    }),
    offset(20),
    shift({ padding: 5 }),
]
